import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { BodyCell } from '../BodyCell'

export const Family = ({
  children,
  spacing,
}: {
  children?: React.ReactNode
  spacing?: number
}) => {
  const { isFamilySelected } = usePlansContext()

  return (
    <BodyCell isSelected={isFamilySelected} spacing={spacing}>
      {children}
    </BodyCell>
  )
}
